import { CommonSubjectType } from '@features/paymentReconciliationModal/types/commonSubjectType'

export enum InvoiceType {
  Invoice = 'invoice',
  CreditNote = CommonSubjectType.CreditNote,
  ExternalInvoice = 'externalInvoice',
}
